import * as React from 'react';
export default class ModalProvider extends React.PureComponent {
    static defaultProps = {
        children: null
    };
    getCloseHandler = (name) => {
        return () => this.props.onClose(name);
    };
    render() {
        const { children, components, modals } = this.props;
        const ModalComponents = [];
        for (const name in modals) {
            const modal = modals[name];
            if (!modal.open) {
                continue;
            }
            const Component = components[name];
            if (!Component) {
                throw new Error(`Couldn't find a modal Component named "${name}"`);
            }
            const onClose = this.getCloseHandler(modal.name);
            ModalComponents.push(React.createElement(Component, { key: name, name: name, metadata: modal.metadata, onClose: onClose }));
        }
        return (React.createElement(React.Fragment, null,
            children,
            ModalComponents));
    }
}
//# sourceMappingURL=ModalProvider.js.map